import styled from 'styled-components';
import TokenInput from '../TokenInput';
import VetsTextInput from '../Vets/Inputs/Text';
import { Container, ModalContainer } from '../BaseModal';
import { useSelector } from 'react-redux';
import { selectSolanaUSDCBalance } from '../../redux/slices/walletSlice';
import { QRCodeCanvas } from 'qrcode.react';
import { useSolana } from '../../hooks/useSolana';
import BackButton from '../BackButton';

const QRCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DepositCrypto = () => {
  const solanaUSDCBalance = useSelector(selectSolanaUSDCBalance);
  const { wallets } = useSolana();

  return (
    <Container>
      <ModalContainer>
        <BackButton />
        <TokenInput
          tokenType='usdc'
          value={String(solanaUSDCBalance)}
          onChange={() => {}}
          type='number'
          disabled={true}
        />
        <QRCodeContainer>
          <QRCodeCanvas
            value={wallets[0]?.address}
            style={{ width: '80%', height: '80%' }}
          />
        </QRCodeContainer>
        <VetsTextInput dark label='NETWORK' value='Solana' disabled />
        <VetsTextInput
          dark
          label='ADDRESS'
          value={wallets[0]?.address}
          onChange={() => {}}
        />
      </ModalContainer>
    </Container>
  );
};

export default DepositCrypto;
